import React, { useState, useRef, useEffect } from 'react';
import { Filter } from 'lucide-react';
import './CategorySelect.css';

const CategorySelect = ({ 
  value, 
  onChange, 
  categories = [], 
  placeholder = "All Categories",
  className = "" 
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleSelectCategory = (category) => {
    setIsOpen(false);
    onChange(category);
  };

  const handleContainerClick = () => {
    setIsOpen(!isOpen);
  };

  const getDisplayValue = () => {
    if (!value) return placeholder;
    return value;
  };

  return (
    <div className={`category-select ${className}`} ref={dropdownRef}>
      <div 
        className={`category-select-container ${isOpen ? 'open' : ''}`}
        onClick={handleContainerClick}
      >
        <Filter size={16} className="filter-icon" />
        <span className="category-display-value">
          {getDisplayValue()}
        </span>
        <div className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <polyline points="6,9 12,15 18,9"></polyline>
          </svg>
        </div>
      </div>
      
      {isOpen && (
        <div className="dropdown-menu">
          <div
            className={`dropdown-item ${!value ? 'selected' : ''}`}
            onClick={() => handleSelectCategory('')}
          >
            {placeholder}
          </div>
          {categories.map((category, index) => (
            <div
              key={index}
              className={`dropdown-item ${value === category ? 'selected' : ''}`}
              onClick={() => handleSelectCategory(category)}
            >
              {category}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CategorySelect;
